var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShieldChecktest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 191,
    viewBox: "0 0 186 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 82.8996C23.25 57.4518 23.25 44.7281 26.1758 40.4475C29.1015 36.167 40.752 32.0718 64.0531 23.8813L68.4923 22.3209C80.6387 18.0514 86.7117 15.9167 93 15.9167C99.2883 15.9167 105.361 18.0514 117.508 22.3209L121.947 23.8813C145.248 32.0718 156.899 36.167 159.824 40.4475C162.75 44.7281 162.75 57.4518 162.75 82.8996C162.75 86.7427 162.75 90.9112 162.75 95.4316C162.75 140.301 129.898 162.075 109.286 171.321C103.695 173.829 100.9 175.083 93 175.083C85.1004 175.083 82.305 173.829 76.7138 171.321C56.1019 162.075 23.25 140.301 23.25 95.4316C23.25 90.9112 23.25 86.7427 23.25 82.8996Z",
    stroke: "#70FF00",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.625 98.6833L84.6967 111.417L112.375 79.5833",
    stroke: "#70FF00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldChecktest);
export default __webpack_public_path__ + "static/media/Shield Checktest.12a7cf56898c5b75678f0812c8fcb4f5.svg";
export { ForwardRef as ReactComponent };